// extracted by mini-css-extract-plugin
export default {"recommendList":"index_recommendList__qbk1n"};